import { request } from "./http";

function asObject(value) {
  return value && typeof value === "object" ? value : {};
}

function asBool(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (["true", "1", "yes", "y", "on", "да"].includes(v)) return true;
    if (["false", "0", "no", "n", "off", "нет"].includes(v)) return false;
  }
  return fallback;
}

function asText(value, fallback = "") {
  const v = String(value ?? "").replace(/\s+/g, " ").trim();
  return v || fallback;
}

function normalizePayload(raw) {
  const root = asObject(raw);
  const item = asObject(root.item);
  const src = { ...root, ...item };

  return {
    enabled: asBool(src.enabled, false),
    bookingDisabled: asBool(
      src.bookingDisabled ??
        src.isBookingDisabled ??
        src.disableBooking,
      false
    ),
    title: asText(src.title, ""),
    message: asText(src.message, ""),
    note: asText(src.note, ""),
    severity: asText(src.severity, "warning").toLowerCase(),
    siteEnabled: asBool(src.siteEnabled, true),
    holidayStyleActive: asBool(src.holidayStyleActive, false),
    version: asText(src.version, ""),
    updatedAt: asText(src.updatedAt, ""),
  };
}

export const siteBannerApi = {
  async getPublicBanner() {
    const raw = await request("/api/public/site-banner");
    return normalizePayload(raw);
  },
};
